import Browser from './Browser';

export default Browser;
